export const STEPS = [
  "credenciais",
  "numero",
  "webhook",
  "identificacao",
  "conclusao",
];

export const estadoInicial = {
  step: 0,
  token: "",
  businessIdManual: "",
  descoberta: null,
  businessId: "",
  wabaId: "",
  phoneNumberId: "",
  whatsappId: null,
  // phone_number_id que o rascunho atual representa. Serve para nao recriar o
  // rascunho quando o usuario volta um step e continua com o mesmo numero.
  rascunhoPhoneNumberId: "",
  webhookUrl: "",
  verifyToken: "",
  appId: "",
  appSecret: "",
  webhookVerificado: false,
  nome: "",
  queueIds: [],
  vertical: "",
  criado: null,
  erro: null,
};

function preselecao(resultado) {
  const business =
    resultado.businesses.length === 1 ? resultado.businesses[0] : null;
  if (!business) return { businessId: "", wabaId: "", phoneNumberId: "" };

  const waba = business.wabas.length === 1 ? business.wabas[0] : null;
  if (!waba) return { businessId: business.business_id, wabaId: "", phoneNumberId: "" };

  const numero =
    waba.phone_numbers.length === 1 ? waba.phone_numbers[0] : null;

  return {
    businessId: business.business_id,
    wabaId: waba.waba_id,
    phoneNumberId: numero ? numero.phone_number_id : "",
  };
}

export function wizardReducer(state, action) {
  switch (action.type) {
    case "AVANCAR":
      return {
        ...state,
        step: Math.min(state.step + 1, STEPS.length - 1),
        erro: null,
      };
    case "VOLTAR":
      return { ...state, step: Math.max(state.step - 1, 0), erro: null };
    case "SET_CAMPO":
      const newState = { ...state, [action.campo]: action.valor };
      // Limpa campos dependentes para manter consistência hierárquica
      if (action.campo === "businessId") {
        newState.wabaId = "";
        newState.phoneNumberId = "";
      } else if (action.campo === "wabaId") {
        newState.phoneNumberId = "";
      }
      return newState;
    case "SET_DESCOBERTA":
      return { ...state, descoberta: action.resultado, ...preselecao(action.resultado) };
    case "SET_RASCUNHO":
      return {
        ...state,
        whatsappId: action.id,
        rascunhoPhoneNumberId: action.phoneNumberId || state.phoneNumberId,
        webhookUrl: action.waba_webhook,
        verifyToken: action.verify_token,
      };
    case "SET_ERRO":
      return { ...state, erro: action.erro };
    default:
      return state;
  }
}

// Voltar do step de webhook para o de numero e continuar com o MESMO numero
// nao pode disparar um novo POST /draft: o backend encontraria o proprio
// rascunho (invisivel na UI) e responderia 409, trancando o wizard.
export function precisaCriarRascunho(state, phoneNumberId) {
  if (!state.whatsappId) return true;
  return state.rascunhoPhoneNumberId !== phoneNumberId;
}

export function podeAvancar(state) {
  switch (STEPS[state.step]) {
    case "credenciais":
      return state.token.trim().length > 0;
    case "numero":
      return state.phoneNumberId.length > 0;
    case "webhook":
      return true;
    case "identificacao":
      return state.nome.trim().length > 0 && state.queueIds.length > 0;
    default:
      return false;
  }
}
